/**
 * Labstep
 *
 * @module components/Metadata/Thread
 * @desc Side menu. Shows thread on open
 */

import { MetadataThreadDetail } from 'labstep-web/components/Metadata/Thread/Detail';
import { ThreadCountIcon } from 'labstep-web/components/Thread/CountIcon';
import ProtocolChildRouter from 'labstep-web/containers/Router/ProtocolChild';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type {
  MetadataThreadContainerProps,
  MetadataThreadProps,
} from './types';

export const MetadataThread: React.FC<MetadataThreadProps> = ({
  metadata,
  navigate,
}) => {
  const viewComponent = ({
    toggleModal,
  }: {
    toggleModal: VoidFunction;
  }) => (
    <ThreadCountIcon
      onClick={toggleModal}
      count={metadata.thread!.comment_count}
    />
  );

  return navigate ? (
    viewComponent({
      toggleModal: navigate,
    })
  ) : (
    <Modal
      header={`Notes on ${metadata.label}`}
      viewComponent={viewComponent}
      content={<MetadataThreadDetail metadata={metadata} />}
    />
  );
};

export const MetadataThreadContainer: React.FC<
  MetadataThreadContainerProps
> = (props) => (
  <ProtocolChildRouter
    route="metadata_show_thread"
    id={props.metadata.id}
  >
    {({ navigate }) => (
      <MetadataThread {...props} navigate={navigate} />
    )}
  </ProtocolChildRouter>
);
